<template>
  <div class="comment__item">
    <div class="comment__item-header">
      <label class="comment__item-name" v-if="comment.name">{{
        comment.name
      }}</label>

      <span class="comment__item-date">
        {{ persianDateTime() }}
      </span>

      <span v-if="comment.isWaitingToConfirm">
        در انتظار تأیید
      </span>
    </div>

    <div class="comment__item-content">
      <div class="comment__item-detail">
        <p v-html="comment.message"></p>
      </div>

      <div class="comment__item-footer" v-if="!comment.isWaitingToConfirm">
       
          <button @click="openReplyForm">
            <i class="icon-arrow-left"></i>
            پاسخ دادن
          </button>
         
       
        <div class="comment__item-reply" :class="{ 'is-show': isReplying }">
          <div class="comment__form-textarea comment__form-textarea--reply">
            <textarea
              v-model="replyMessage"
              @keyup="checkMessageIsValid"
              ref="replyMessage"
              :maxlength="commentViewDataModel.commentLength"
              :disabled="isVoting"
              placeholder="دیدگاه خود درباره این مطلب را اینجا بنویسید"
              autocomplete="off"
            ></textarea>

            
          </div>

          <span class="form-validation" v-if="replyMessageError.length">{{
            replyMessageError
          }}</span>

          <div class="comment__form-submit">
            <button
              :disabled="!replyMessage.length"
              @click="replyComment"
              class="btn btn--primary p--0"
            >
              {{ sendButtonText }}
            </button>
          </div>
        </div>

        <transition-group name="fade">
          <Comment
            v-for="comment in comment.comments"
            :key="comment.id"
            :comment="comment"
          />
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
import { postRequest } from "../../../Helpers/api";
import { dateFaFormatType2 } from "../../../Helpers/format";

export default {
  name: "Comment",

  props: {
    comment: {
      type: Object,
    },
  },

  data() {
    return {
      commentViewDataModel: window.CommentViewData,
      isVoting: false,
      replyMessage: "",
      replyMessageError: "",
      commentMessageIsValid: false,
      isReplying: false,
    };
  },

  computed: {
    sendButtonText() {
      return this.isVoting ? "لطفا کمی صبر کنید" : "ارسال دیدگاه";
    },
  },

  methods: {
    // convert comment created date to persian date
    persianDateTime() {
      return dateFaFormatType2(this.comment.createDate);
    },

    // set user avatar
    setAvatarPath(avatar) {
      if (avatar) {
        return this.commentViewDataModel.prefixAvatarPath + avatar;
      }

      return this.commentViewDataModel.defaultAvatarPath;
    },

    // like comment
    commentLike(isLiked) {
      if (this.commentViewDataModel.isUserAuthenticated) {
        if (!this.isVoting) {
          this.isVoting = true;

          let payload = {
            url: this.commentViewDataModel.voteUrl,
            data: {
              id: this.comment.id,
              isLiked: isLiked,
            },
          };

          postRequest(payload).then((response) => {
            this.isVoting = false;

            if (response.isSucceed || response.model.isVoted) {
              this.comment.positive = response.model.positiveCount;
              this.comment.negative = response.model.negativeCount;
            }
          });
        }
      } else {
        this.popupLoginModal();
      }
    },

    // open comment reply section
    openReplyForm() {
      if (this.commentViewDataModel.isUserAuthenticated) {
        this.isReplying = !this.isReplying;

        if (this.isReplying) {
          if (!this.replyMessage.length) {
            this.replyMessage = "@" + this.comment.name + "\n";
          }

          this.$refs.replyMessage.focus();
        }
      } else {
        this.popupLoginModal();
      }
    },

    // reply to comment
    replyComment() {
      this.replyMessage = this.replyMessage.trim();

      this.checkMessageIsValid();

      if (!this.isVoting && this.commentMessageIsValid) {
        this.isReplying = true;

        let payload = {
          url: this.commentViewDataModel.replyUrl,
          data: {
            commentId: this.comment.id,
            topicId: this.commentViewDataModel.topicId,
            message: this.replyMessage,
          },
        };

        postRequest(payload).then((response) => {
          if (response.isSucceed && this.comment.comments) {
            this.comment.comments.push(response.model);
          }

          this.isVoting = false;
          this.replyMessage = "";
          this.isReplying = false;
        });
      }
    },

    // check message is valid or not
    checkMessageIsValid() {
      this.replyMessageError = "";

      if (this.replyMessage !== null && this.replyMessage.length) {
        if (!this.replyMessage.length) {
          this.commentMessageIsValid = false;
          this.replyMessageError = "ورود پیام الزامی است";
        } else {
          this.commentMessageIsValid = true;
          this.replyMessageError = "";
        }
      } else {
        this.commentMessageIsValid = false;
        this.replyMessageError = "ورود پیام الزامی است";
      }
    },

    // check user authenticated or not and open login modal
    popupLoginModal() {
      window.popupLoginRegisterModal();
    },
  },
};
</script>
